import { defineMessages } from "react-intl";

const baseId = "t.pages.UsersReferenceStepTwo.";

export default defineMessages({
  UserPanelTitle: {
    id: baseId + "UserPanelTitle",
    defaultMessage: "User Detail",
  },
  ApplicationPanelTitle: {
    id: baseId + "ApplicationPanelTitle",
    defaultMessage: "Finded Applications",
  },
  EntitlementPanelTitle: {
    id: baseId + "EntitlementPanelTitle",
    defaultMessage: "Finded Entitlements",
  },
  CTABack: {
    id: baseId + "CTABack",
    defaultMessage: "Back",
  },
  applicationModalTitle: {
    id: baseId + "applicationModalTitle",
    defaultMessage: "Accounts",
  },
  noFilteredAccountFound: {
    id: baseId + "noFilteredAccountFound",
    defaultMessage: "No accounts found for this entitlement",
  },
  entitlementsOfBR: {
    id: baseId + "entitlementsOfBR",
    defaultMessage: "Business Role's entitlements",
  },
  moreInfoPanelTitle: {
    id: baseId + "moreInfoPanelTitle",
    defaultMessage: "More info",
  },
  managers: {
    id: baseId + "managers",
    defaultMessage: "Managers",
  },
  ous: {
    id: baseId + "ous",
    defaultMessage: "Ous",
  },
  noResultFound: {
    id: baseId + "noResultFound",
    defaultMessage: "No result found",
  },
  //DETAIL PANEL
  PanelDetailRequestLabelID: {
    id: baseId + "PanelDetailRequestLabelID",
    defaultMessage: "Id",
  },
  PanelDetailRequestLabelName: {
    id: baseId + "PanelDetailRequestLabelName",
    defaultMessage: "Name",
  },
  PanelDetailRequestLabelSurname: {
    id: baseId + "PanelDetailRequestLabelSurname",
    defaultMessage: "Surname",
  },
  PanelDetailRequestLabelType: {
    id: baseId + "PanelDetailRequestLabelType",
    defaultMessage: "Type",
  },
  PanelDetailRequestLabelCompany: {
    id: baseId + "PanelDetailRequestLabelCompany",
    defaultMessage: "Company",
  },
  PanelDetailRequestLabelManager: {
    id: baseId + "PanelDetailRequestLabelManager",
    defaultMessage: "Manager",
  },
  PanelDetailRequestLabelOU: {
    id: baseId + "PanelDetailRequestLabelOU",
    defaultMessage: "Organizational Unit",
  },
  PanelDetailRequestLabelIdentity: {
    id: baseId + "PanelDetailRequestLabelIdentity",
    defaultMessage: "Identity",
  },

  //FILTER
  allFilterLabelForm: {
    id: baseId + "allFilterLabelForm",
    defaultMessage: "ID,USER ID",
  },
});
